import { createReducer, on } from "@ngrx/store";
import { USER_MENU } from "../actions/modules.action";
import { ModulesWithSubmodulesModel } from "../models/module.model";

export interface ModuleState {
  modulesWithSubmodules: ModulesWithSubmodulesModel[];
}

const INITIAL_STATE: ModuleState = {
  modulesWithSubmodules: [],
};

export const ModuleReducer = createReducer(
  INITIAL_STATE,
  on(USER_MENU, (state, { menu }) => ({
    ...state,
    modulesWithSubmodules: menu,
  })),
);
